// extracted by mini-css-extract-plugin
module.exports = {"root":"PageFooter_root__1CUV-"};